import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSession } from "@/store/session";

export function RequireAuth({ children }: { children: ReactNode }) {
  const hasHydrated = useSession((s) => s.hasHydrated);
  // A valid refresh token counts as authed: the access token will be revived
  // silently (App bootstrap + 401 retry), so don't bounce to /login meanwhile.
  const authed = useSession((s) => s.isValid() || s.hasValidRefresh());
  const location = useLocation();
  if (!hasHydrated) return null;
  if (!authed) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ returnTo: location.pathname + location.search }}
      />
    );
  }
  return <>{children}</>;
}

export function RedirectIfAuthed({ children }: { children: ReactNode }) {
  const hasHydrated = useSession((s) => s.hasHydrated);
  const authed = useSession((s) => s.isValid() || s.hasValidRefresh());
  if (!hasHydrated) return null;
  if (authed) return <Navigate to="/chat" replace />;
  return <>{children}</>;
}
